import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
// import {Modal} from 'react-bootstrap';
import isEmpty from 'lodash/isEmpty';
import { AppSettings } from '../../constants';
import folder from 'assets/img/folder.png';
import word from 'assets/img/file_word.png';
import excel from 'assets/img/file_excel.png';
import pdf from 'assets/img/file_pdf.png';
import ppt from 'assets/img/file_pp.png';
import video from 'assets/img/file_video.png';
import other from 'assets/img/file_other.png';
import * as LotActionType from '../constants';
import {isMobile} from 'react-device-detect';
import PreviewVideoWO from '../../Work-Orders/Components/PreviewVideoWO';
import { PreviewImage } from 'components/PreviewImage';
class LotDocument extends Component {
  static propTypes = {
    match: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object,
    dispatch: PropTypes.func,
    LotProfile: PropTypes.object,
    UserProfile: PropTypes.object,
    LotDocuments: PropTypes.array,
    LotAWSCredential: PropTypes.object,
    LotStore: PropTypes.object,
    lotId: PropTypes.any
  }

  constructor(props) {
    super(props);
    this.state = {
      files: [],
      show: false,
      previewUrl: null,
      isPreviewPDF: null,
      cancelUploadList: {},
      deleteUploadList: {},
      videoUrl: null,
      showDialog: false
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleHideEmbedPreview);
    if (AppSettings.clientTypeValue === 'Homeowner') {
      if (!this.props.LotStore.HomeownerLots.length) {
        this.onGetBuilderProfile();
      } else {
        const lotFound = this.props.LotStore.HomeownerLots.find(item => item.lot.id === this.props.LotProfile.id);
        if (lotFound) { this.onBindHomeownerLotDocument(lotFound.builderProfile); }
        else { this.onGetBuilderProfile(); }
      }
    } else {
      this.props.dispatch({
        type: LotActionType.GET_LOT_DOCUMENT_ASYNC,
        params: {
          lotId: this.props.lotId
        }
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleHideEmbedPreview);
    this.props.dispatch({
      type: LotActionType.RESET_LOT_DOCUMENT
    });
  }

  onGetBuilderProfile = () => {
    this.props.dispatch({
      type: LotActionType.GET_HOMEOWNER_LOT_LIST_ASYNC,
      params: {lotId: this.props.LotProfile.id},
      callbackGetBuilderProfile: (builderProfile) => {this.onBindHomeownerLotDocument(builderProfile);}
    });
  }

  onBindHomeownerLotDocument = (builderProfile) => {
    /**
     * BuilderProfile get from homeowner portal by server
     */
    this.props.dispatch({
      type: LotActionType.GET_HOMEOWNER_LOT_DOCUMENT_ASYNC,
      params: {
        endpoint: builderProfile.builderHost,
        headers: {
          key: builderProfile.headerKey,
          value: builderProfile.securityToken
        },
        lotId: this.props.LotProfile.id
      }
    });
  }

  handleHideEmbedPreview = event => {
    if (this.embedPreview && !this.embedPreview.contains(event.target)) {
      this.setState({
        isPreviewPDF: null
      });
    }
  }

  onDrop = (e) => {
    let newFiles = [...this.state.files];
    e.map((file) => {
      file.uploadId = _.uniqueId(); //uuidv4();
      newFiles.push(file);
      this.setState({
        files: newFiles
      });
    });
    this.handleUploadFile(e);
  }

  handleShow = (file) => {
    const extension = file.fileName.split('.').pop().toLowerCase();
    const imageType = ['jpg', 'jpeg', 'png', 'gif'];
    const videoType = ['mp4', 'm4v', 'mid', 'mkv', 'webm', 'mov', 'avi', 'wmv'];
    if (imageType.includes(extension)) {
      this.setState({
        show: true,
        previewUrl: file.url
      });
    }
    if (extension === 'pdf') {
      this.setState({
        isPreviewPDF: file.url
      }, () => {
        if (isMobile) {
          window.open(this.state.isPreviewPDF, '_blank');
        }
      });
    }
    if (videoType.includes(extension)) {
      this.setState({
        showDialog: true,
        videoUrl: file.url
      });
    }
  }

  handleClose = () => {
    this.setState({ show: false });
  }

  handleUploadFile = (files) => {
    //call api to get key AWS
    this.props.dispatch({
      type: LotActionType.SETUP_LOT_DOCUMENT_AWS_ASYNC,
      params: {
        resourcePath: `lots/${this.props.LotProfile.id}`
      },
      callback: () => this.handleUploadFileToS3(files)
    });
  }

  handleUploadFileToS3 = (files) => {
    files.map((file) => {
      this.props.dispatch({
        type: LotActionType.UPLOAD_LOT_DOCUMENT_TO_S3_ASYNC,
        params: {
          lotId: this.props.LotProfile.id,
          config: this.props.LotAWSCredential,
          file: file
        },
        callback: this.callbackHandleUploadFileToS3(file.name)
      });
    });
  }

  callbackHandleUploadFileToS3 = fileName => (status, data) => {
    if (status === 'pending') {
      const {cancelUploadList} = this.state;
      cancelUploadList[data.uploadId] = data.cancelUpload;
      this.setState({
        cancelUploadList
      });
    } else if (status === 'delete') {
      const {deleteUploadList} = this.state;
      deleteUploadList[data.uploadId] = data.deleteFile;
      this.setState({
        deleteUploadList
      });
    } else {
      this.handleUploadFileToServer(data.data, fileName);
    }
  }

  handleUploadFileToServer = (data, fileName) => {
    this.props.dispatch({
      type: LotActionType.UPLOAD_LOT_DOCUMENT_TO_SERVER_ASYNC,
      params: {
        lotId: this.props.LotProfile.id,
        data: {
          url: data.Location,
          key: data.Key,
          fileName: fileName,
          caption: ''
        }
      },
      callback: (status, res) => {
        if (status) {
          this.setState({
            files: this.state.files.filter(element => element.name !== res[0].fileName)
          });
        }
      }
    });
  }

  handleCancelUpload = (item) => {
    const {cancelUploadList} = this.state;
    if (!isEmpty(cancelUploadList) && Object.keys(cancelUploadList).includes(item.uploadId)) {
      cancelUploadList[item.uploadId]();
      delete cancelUploadList[item.uploadId];
      this.setState({
        files: this.state.files.filter((element) => element.uploadId !== item.uploadId),
        cancelUploadList
      });
    }
    const {deleteUploadList} = this.state;
    if (!isEmpty(deleteUploadList) && Object.keys(deleteUploadList).includes(item.uploadId)) {
      deleteUploadList[item.uploadId]();
      delete deleteUploadList[item.uploadId];
      this.setState({
        files: this.state.files.filter((element) => element.uploadId !== item.uploadId),
        deleteUploadList
      });
    }
  }

  handleDownloadFile = (file) => {
    if (AppSettings.clientTypeValue === 'Homeowner') {
      const lotFound = this.props.LotStore.HomeownerLots.find(item => item.lot.id === this.props.LotProfile.id);

      this.props.dispatch({
        type: LotActionType.SETUP_HOMEOWNER_LOT_DOCUMENT_AWS_ASYNC,
        params: {
          endpoint: lotFound.builderProfile.builderHost,
          headers: {
            key: lotFound.builderProfile.headerKey,
            value: lotFound.builderProfile.securityToken
          },
          param: {
            resourcePath: `lots/${this.props.LotProfile.id}`
          }
        },
        callback: () => {
          this.props.dispatch({
            type: LotActionType.DOWNLOAD_LOT_DOCUMENT_ASYNC,
            params: {
              config: this.props.LotAWSCredential,
              fileName: file.fileName,
              key: file.key
            }
          });
        }
      });
      this.onBindHomeownerLotDocument(lotFound.builderProfile);
    } else {
      this.props.dispatch({
        type: LotActionType.SETUP_LOT_DOCUMENT_AWS_ASYNC,
        params: {resourcePath: `lots/${this.props.LotProfile.id}`},
        callback: () => {
          this.props.dispatch({
            type: LotActionType.DOWNLOAD_LOT_DOCUMENT_ASYNC,
            params: {
              config: this.props.LotAWSCredential,
              fileName: file.fileName,
              key: file.key
            }
          });
        }
      });
    }
  }

  handleDeleteFile = (file) => {
    this.props.dispatch({
      type: LotActionType.REMOVE_LOT_DOCUMENT_ASYNC,
      params: {
        id: this.props.LotProfile.id,
        docId: file.id
      }
    });
  }

  handleCloseVideo = (callback) => {
    this.setState({ showDialog: false, videoUrl: null}, callback);
  }

  renderFileTypeIcon = (item) => {
    const extWord = ['doc', 'docx'];
    const extExcel = ['xls', 'xlsx'];
    const extPpt = ['ppt', 'pptx'];
    const extImage = ['jpg', 'jpeg', 'png', 'gif'];
    const extVideo = ['mp4', 'm4v', 'mid', 'mkv', 'webm', 'mov', 'avi', 'wmv'];
    const ext = item.fileName.split('.').pop().toLowerCase();
    if (extWord.includes(ext)) {return word;}
    else if (extExcel.includes(ext)) {return excel;}
    else if (extPpt.includes(ext)) {return ppt;}
    else if (extPpt.includes(ext)) {return ppt;}
    else if (extVideo.includes(ext)) {return video;}
    else if (ext === 'pdf') {return pdf;}
    else if (extImage.includes(ext)) {return item.url;}
    else {return other;}
  }

  renderFileUpload = () => {
    return <ul className='file-upload-list'>
      {(this.props.LotDocuments.length > 0) &&
        this.props.LotDocuments.map(f =>
          <li key={f.fileName}>
            <div style={{
              width: 50,
              height: 60,
              marginLeft: 15,
              marginRight: 10,
              borderRadius: 2,
              verticalAlign: 'top',
              backgroundImage: `url(${this.renderFileTypeIcon(f)})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              display: 'inline-block'
            }} onDoubleClick={() => this.handleShow(f)} />
            {/*<img
              src={this.renderFileTypeIcon(f)}
              alt={f.fileName}
            onDoubleClick={() => this.handleShow(f)} />*/}
            <div className='file-info'>
              <p>{f.fileName}</p>
              <p className='uploaded-by'>Uploaded by <span className='author-name'>{f.createdBy}</span></p>
            </div>
            <div className='download-button-wrapper lot-document-download-btn' onClick={() => this.handleDownloadFile(f)}>
              <div className='download-button icon-download-ic' />
            </div>
            <div className='remove-button-wrapper lot-document-remove-btn' onClick={() => this.handleDeleteFile(f)}>
              <div className='icon-remove-ic' />
            </div>
          </li>
        )
      }
      {
        this.state.files.map(f =>
          <li key={f.name}>
            <i className='fa fa-spin fa-spinner loading-ic' />
            <div className='file-info'>
              <p>{f.name}</p>
              <p className='uploaded-by'>Uploaded by <span className='author-name'>{this.props.UserProfile.fullName}</span></p>
            </div>
            <div className='remove-button-wrapper lot-document-remove-btn' onClick={() => this.handleCancelUpload(f)}>
              <div className='remove-button icon-remove-ic' />
            </div>
          </li>
        )
      }
    </ul>;
  }

  renderNoFiles = () => {
    return <div className='lot-document-no-files-block'>
      <img className='lot-document-no-files-ic' src={folder} alt='no-files' />
      <p className='lot-document-no-files-text'>No files</p>
    </div>;
  }

  renderHomeownerFiles = (documents) => {
    return <ul className='file-upload-list'>
      {
        documents.map(f =>
          <li key={f.fileName}>
            <div style={{
              width: 50,
              height: 60,
              marginLeft: 15,
              marginRight: 10,
              borderRadius: 2,
              verticalAlign: 'top',
              backgroundImage: `url(${this.renderFileTypeIcon(f)})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              display: 'inline-block'
            }} onDoubleClick={() => this.handleShow(f)} />
            {/*<img
              src={this.renderFileTypeIcon(f)}
              alt={f.fileName}
            onDoubleClick={() => this.handleShow(f)} />*/}

            <div className='file-info'>
              <p>{f.fileName}</p>
              <p className='uploaded-by'>Uploaded by <span className='author-name'>{f.createdBy}</span></p>
            </div>
            <div
              className='download-button-wrapper lot-document-download-btn'
              onClick={() => this.handleDownloadFile(f)}
              style={{ right: 20 }}>
              <div className='download-button icon-download-ic' />
            </div>
          </li>
        )
      }
    </ul>;
  }

  renderHomeownerDocument = (documents) => {
    if (documents.length) {
      return this.renderHomeownerFiles(documents);
    }
    return this.renderNoFiles();
  }

  render() {
    const {show, isPreviewPDF, previewUrl, videoUrl, showDialog} = this.state;
    return <div className='lot-document-wrapper'>
      {isPreviewPDF && !isMobile && [
        <embed src={isPreviewPDF} className='pdf-preview-dialog' ref={ref => {this.embedPreview = ref;}} />,
        <i className='close-embed-preview fa fa-close' />
      ]}

      <PreviewImage
        show={show}
        imageUrl={previewUrl}
        handleClose={this.handleClose}
        isPDF={false}
      />

      {videoUrl && [
        <PreviewVideoWO
          // loading
          data={videoUrl}
          showDialog={showDialog}
          handleCloseVideo={this.handleCloseVideo}
        />
      ]}

      {/* <Modal show={this.state.show} onHide={this.handleClose} dialogClassName='preview-dialog'>
        <Modal.Header closeButton />
        <Modal.Body style={{backgroundImage: `url(${this.state.previewUrl})`}} />
      </Modal> */}

      {AppSettings.clientTypeValue === 'Builder'
        ? <Dropzone
          disableClick
          ref={(node) => { this.dropzoneRef = node; }}
          onDrop={this.onDrop.bind(this)}
          className='lot-dropzone' >
          <div className='upload-block'>
            <span className='files-upload-ic'>
              <i className='fa fa-cloud-upload' />
            </span>
                Drag files here or <span className='files-browse-txt' onClick={() => {this.dropzoneRef.open();}}>browse.</span>
          </div>

          {(this.props.LotDocuments.length || this.state.files.length) ? this.renderFileUpload() : this.renderNoFiles()}

        </Dropzone>
        : this.renderHomeownerDocument(this.props.LotDocuments)
      }
    </div>;
  }
}

const mapStateToProps = (state) => {
  return {
    LotProfile: state.LotStore.LotProfile,
    UserProfile: state.UserStore.UserProfile,
    LotDocuments: state.LotStore.LotDocuments,
    LotAWSCredential: state.LotStore.LotAWSCredential,
    LotStore: state.LotStore
  };
};

export default connect(mapStateToProps)(LotDocument);



// WEBPACK FOOTER //
// ./src/Lots/Containers/lot-view-document.js